import React from 'react'
import { TextSM } from '../../../../Components/Text/NormalText';
import { Link, useParams } from 'react-router-dom';
import { NewPill } from '../../../../Components/Utils/StatusPills';
import ViewMore from './ViewMore';
import NuDate from '../../../../Components/Utils/NuDate';

function OutgoingCard({ item,getData }) {
   
    return (
        <div className="w-full border bg-white rounded-lg shadow-xl mt-1.5 mb-2">
   
        <div className="flex justify-between bg-[#ECEBF3]  rounded-t-lg items-center px-4 py-2">
          <p className=" w-8 h-5 bg-slate-300  flex justify-center font-medium text-mainColor-500 items-center text-[12px] rounded-lg">
            {item?.invoiceOutId || "#"}
          </p>
          <div className=" flex items-center gap-3">
            <div className="flex items-center gap-2 overflow-hidden">
              {item?.status &&
               
                  <NewPill text={item?.status} />
              
                }
            </div>
            <ViewMore id={item?.invoiceOutId}         getData={getData}
  data={item} />
          </div>
        </div>
        <div className=" px-2 pb-2">
          <div className=" px-2 w-full h-8 mt-2 truncate  overflow-hidden">
            <Link
              className="hover:text-blue-600 text-mainColor-400 font-semibold text-[12px] lg:text-[12px] xl:text-[12px] w-full flex justify-between items-center"
              to={`/invoice/invoice-outgoing/view/${item?.invoiceOutId}`}
              state={{ data: item }}
            >
              {item?.ref || "-"}
            </Link>
          </div>
          <div
            className="w-full flex justify-between items-center flex-wrap gap-2 mb-2 rounded-md p-2"
            style={{ border: "1px solid #C0C0C0" }}
          >
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Type : " || "-"} />
                <div className=" text-xs ">{item?.Type || "-"}</div>
              </div>
            </div> */}
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Customer : " || "-"} />
                <div className=" text-xs ">{item?.clientName || "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Amount : " || "-"} />
                <div className=" text-xs ">{item?.amount || "-"}</div>
              </div>
            </div>
             <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Paymt Due Date : " || "-"} />
                <div className=" text-xs ">
                  {(item?.paymentDueDate != "None" && (
                    <NuDate value={item?.paymentDueDate} format="DD-MMM-YY" />
                  )) ||
                    "-"}
                </div>
              </div>
            </div>
             {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Response Date : " || "-"} />
                <div className=" text-xs ">
                  {(item?.ResponseDate != "None" && (
                    <NuDate value={item?.ResponseDate} format="DD-MMM-YY" />
                  )) ||
                    "-"}
                </div>
              </div>
            </div> */}
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Mode Of Paymt : " || "-"} />
                <div className=" text-xs ">{item?.modeOfPayment || "-"}</div>
              </div>
            </div>
  
           
  
           
          </div>
        </div>
      </div>
    );
  }

export default OutgoingCard
